module.exports = __webpack_public_path__ + "media/images/company/company_03_02-83c88eea645c608377d546707106876d.jpg";